<script>
  // Kitchen-sink page with zero real purpose at runtime — it exists purely so the eager
  // `import.meta.glob('../admin_site/pages/**/*.svelte', { eager: true })` page loader
  // (app/javascript/entrypoints/admin-site.js) forces Vite to compile every shared component
  // during `bin/vite build`. No route/controller renders this page; delete once every page
  // vertical (Phase C) is imported into the app for real and exercises these components itself.
  import TextField from '../../components/form/text_field.svelte'
  import TextareaField from '../../components/form/textarea_field.svelte'
  import SelectField from '../../components/form/select_field.svelte'
  import CheckboxField from '../../components/form/checkbox_field.svelte'
  import ToggleField from '../../components/form/toggle_field.svelte'
  import DateField from '../../components/form/date_field.svelte'
  import TimeField from '../../components/form/time_field.svelte'
  import NumberField from '../../components/form/number_field.svelte'
  import EmojiTextField from '../../components/form/emoji_text_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'

  import DataTable from '../../components/data_table.svelte'
  import Paginator from '../../components/paginator.svelte'
  import FilterTabs from '../../components/filter_tabs.svelte'
  import SearchInput from '../../components/search_input.svelte'
  import Drawer from '../../components/drawer.svelte'
  import Modal from '../../components/modal.svelte'
  import ConfirmDialogHost from '../../components/confirm_dialog_host.svelte'
  import { confirm } from '../../components/confirm.js'

  import StateChip from '../../components/badges/state_chip.svelte'
  import VisibilityBadge from '../../components/badges/visibility_badge.svelte'
  import AgeBadge from '../../components/badges/age_badge.svelte'
  import { SUBMISSION_STATE } from '../../components/badges/chip_maps.js'

  import Card from '../../components/card.svelte'
  import StatTile from '../../components/stat_tile.svelte'
  import PageHeader from '../../components/page_header.svelte'

  import LineChart from '../../components/charts/line_chart.svelte'
  import BarChart from '../../components/charts/bar_chart.svelte'

  import ClickableImage from '../../components/lightbox/clickable_image.svelte'
  import ClickableVideo from '../../components/lightbox/clickable_video.svelte'

  import ScheduleEditor from '../../components/schedule_editor.svelte'
  import MultipleDateSelector from '../../components/multiple_date_selector.svelte'
  import MultiStep from '../../components/multi_step.svelte'
  import TargetingEditor from '../../components/targeting_editor.svelte'
  import MultiSelect from '../../components/multi_select.svelte'

  import GoogleMap from '../../components/google_map.svelte'
  import PlaceSearch from '../../components/place_search.svelte'

  import ImageUploadDrawer from '../../components/image_upload_drawer.svelte'
  import ImageLibraryDrawer from '../../components/image_library_drawer.svelte'
  import ImageSelector from '../../components/image_selector.svelte'

  let text = $state('')
  let textarea = $state('')
  let select = $state('')
  let checked = $state(false)
  let toggled = $state(false)
  let date = $state('')
  let time = $state('')
  let number = $state(0)
  let emoji = $state('')
  let emojiText = $state('')

  let tableItems = $state([{ id: '1', name: 'Row one' }])
  let drawerOpen = $state(false)
  let modalOpen = $state(false)
  let uploadOpen = $state(false)
  let libraryOpen = $state(false)

  let scheduleValue = $state({
    recur_on: 'weekly',
    time_zone: 'America/New_York',
    starts_at: null,
    ends_at: null,
    starts_on: null,
    ends_on: null,
    sunday: true,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    schedule_exclusions_attributes: [],
    schedule_inclusions_attributes: []
  })
  let selectedDates = $state([])
  let wizardIndex = $state(0)
  let targeting = $state({
    category_ids: [],
    sub_category_ids: [],
    places: [],
    excluded_sub_category_ids: [],
    excluded_place_ids: []
  })
  let multiSelectValue = $state([])
  let lat = $state(40.7128)
  let lng = $state(-74.006)
  let galleryValue = $state([])
</script>

<div class="p-6 flex flex-col gap-8">
  <PageHeader title="Component kitchen sink">
    {#snippet actions()}
      <SubmitButton label="Example action" full={false} />
    {/snippet}
  </PageHeader>

  <TextField bind:value={text} label="Text" name="text" />
  <TextareaField bind:value={textarea} label="Textarea" name="textarea" />
  <SelectField bind:value={select} label="Select" name="select" options={['a', 'b']} />
  <CheckboxField bind:checked label="Checkbox" name="checkbox" />
  <ToggleField bind:checked={toggled} label="Toggle" name="toggle" />
  <DateField bind:value={date} label="Date" name="date" />
  <TimeField bind:value={time} label="Time" name="time" />
  <NumberField bind:value={number} label="Number" name="number" />
  <EmojiTextField bind:emoji bind:text={emojiText} name="emoji_text" />

  <DataTable items={tableItems}>
    {#snippet header()}
      <tr><th>Name</th></tr>
    {/snippet}
    {#snippet row(item)}
      <tr><td>{item.name}</td></tr>
    {/snippet}
  </DataTable>

  <Paginator page={1} pages={3} count={30} />
  <FilterTabs tabs={[{ key: 'all', label: 'All' }]} active="all" />
  <SearchInput value="" />

  <button type="button" class="btn btn-sm" onclick={() => (drawerOpen = true)}>Open drawer</button>
  <Drawer bind:open={drawerOpen} title="Example drawer">Drawer content</Drawer>

  <button type="button" class="btn btn-sm" onclick={() => (modalOpen = true)}>Open modal</button>
  <Modal bind:open={modalOpen} title="Example modal">Modal content</Modal>
  <ConfirmDialogHost />
  <button type="button" class="btn btn-sm" onclick={() => confirm({ title: 'Confirm?' })}>Trigger confirm</button>

  <StateChip label="Approved" tone={SUBMISSION_STATE.approved} />
  <VisibilityBadge visibility="public" />
  <AgeBadge timestamp={new Date().toISOString()} />

  <Card title="Example card">Card body</Card>
  <StatTile label="Submissions" value={42} delta={3} />

  <LineChart labels={['Mon', 'Tue']} datasets={[{ label: 'Series', data: [1, 2] }]} />
  <BarChart labels={['Mon', 'Tue']} datasets={[{ label: 'Series', data: [1, 2] }]} horizontal />

  <ClickableImage url="https://placehold.co/200" title="Example" />
  <ClickableVideo url="https://example.com/video.mp4" thumbnailUrl="https://placehold.co/200" title="Example" />

  <ScheduleEditor bind:value={scheduleValue} />
  <MultipleDateSelector bind:value={selectedDates} label="Dates" />

  <MultiStep steps={[{ key: 'one', label: 'Step one' }, { key: 'two', label: 'Step two' }]} bind:activeIndex={wizardIndex}>
    {#snippet step(index, current)}
      <p>Step content for {current.label}</p>
    {/snippet}
  </MultiStep>

  <TargetingEditor
    bind:value={targeting}
    categories={[{ value: '1', label: 'Food' }]}
    subCategories={[{ value: '1', label: 'Pizza' }]}
    places={[{ value: '1', label: 'Example Place' }]}
    allowPlaceRadius
  />

  <MultiSelect bind:value={multiSelectValue} options={[{ value: '1', label: 'Option' }]} label="Multi select" />

  <GoogleMap bind:lat bind:lng />
  <PlaceSearch onselect={() => {}} />

  <button type="button" class="btn btn-sm" onclick={() => (uploadOpen = true)}>Open upload drawer</button>
  <ImageUploadDrawer bind:open={uploadOpen} />

  <button type="button" class="btn btn-sm" onclick={() => (libraryOpen = true)}>Open library drawer</button>
  <ImageLibraryDrawer bind:open={libraryOpen} />

  <ImageSelector bind:value={galleryValue} label="Gallery" />
</div>
